/*
 * module for testing select helpers with multi selects
 */

rs.module("development/codedemos/selecthelperdemo", ["common/select-helper"],

    function (selectHelper) {

        function initialize(jsSelectors, backendUrls) {

            var singleSelect = $.js(jsSelectors.singleSelect);
            var multiSelect = $.js(jsSelectors.multiSelect);

            var singleSelectHelper = selectHelper.getHelper(singleSelect);
            var multiSelectHelper = selectHelper.getHelper(multiSelect);

            var prependOptions = $.js(jsSelectors.prependOptions);
            var appendOptions = $.js(jsSelectors.appendOptions);
            var replaceOptions = $.js(jsSelectors.replaceOptions);
            var loadOptionsFrom = $.js(jsSelectors.loadOptionsFrom);

            var maintainSelected = $.js(jsSelectors.maintainSelected);
            var includeSelected = $.js(jsSelectors.includeSelected);
            var withBlank = $.js(jsSelectors.withBlank);

            prependOptions.click(function () {
                singleSelectHelper.prependOptions(_getNewOptions());
                multiSelectHelper.prependOptions(_getNewOptions());
            });

            appendOptions.click(function () {

                singleSelectHelper.appendOptions(_getNewOptions());
                multiSelectHelper.appendOptions(_getNewOptions());
            });

            replaceOptions.click(function () {

                var maintainSelectedChecked = maintainSelected.is(":checked");
                var withBlankChecked = withBlank.is(":checked");

                singleSelectHelper.replaceOptions(_getNewOptions(), { maintainSelection: maintainSelectedChecked, withBlank: withBlankChecked });
                multiSelectHelper.replaceOptions(_getNewOptions(), { maintainSelection: maintainSelectedChecked, withBlank: withBlankChecked });
            });

            loadOptionsFrom.click(function () {

                var maintainSelectedChecked = maintainSelected.is(":checked");
                var withBlankChecked = withBlank.is(":checked");
                var selected = includeSelected.is(":checked");

                singleSelectHelper.loadOptionsFrom(backendUrls.loadOptionsFrom, { markSelected: selected }, { maintainSelection: maintainSelectedChecked, withBlank: withBlankChecked });
                multiSelectHelper.loadOptionsFrom(backendUrls.loadOptionsFrom, { markSelected: selected }, { maintainSelection: maintainSelectedChecked, withBlank: withBlankChecked });
            });

            function _getNewOptions() {

                var selected = includeSelected.is(":checked");

                return [
                    { Text: "Option 1 (new)", Value: "1a", Selected: selected },
                    { Text: "Option 2 (new)", Value: "2a", Selected: selected },
                    { Text: "Option 3 (new)", Value: "3a" },
                    { Text: "Option 4 (new)", Value: "4a" },
                ]
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);